// frontend/src/components/tutorial/TutorialSimulator.jsx
import { useEffect } from 'react';

const TutorialSimulator = () => {
    useEffect(() => {
        window.__TUTORIAL_SIMULATED_DATA__ = null;
        return () => {
            window.__TUTORIAL_SIMULATED_DATA__ = null;
        };
    }, []);

    return null;
};

export default TutorialSimulator;